/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Globals from "../shared/Globals";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormLabel from "./FormLabel";

export default class Wound2 extends BaseCom {

    getSizeCM2 = () => {
        return Number(this.props.item.sizeLength * this.props.item.sizeWidth).toFixed();
    }

    render() {
        return (
            <Card title={this.props.title}>
                <div className="mb-3">
                {this.props.item.fileIdent ? <img src={Globals.getImageURL('/api/wound/image/' + this.props.item.fileIdent)} className="card-img-top" alt="" />
                    : <img src="/img/placeholder.png" className="card-img-top" alt="" />}
                    </div>
                    <div className="fs-4 text-center">{this.props.item.sizeLength}x{this.props.item.sizeWidth} cm <span className="text-primary">({this.getSizeCM2()}cm<sup><L>2</L></sup>)</span></div>
            </Card>
        );
    }
}